import React, { FC, useRef } from 'react';
import classNames from 'classnames';
import cls from './DayInput.module.css';

export const DayInput = ({ onChange, value, onSubmit, classes, isDisabled }) => {
    const inputRef = useRef(null);

    const onChangeHandler = (event) => {
        onChange?.(event.target.value);
    };

    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter') {
            onSubmit?.();
            event.preventDefault();
            inputRef.current?.blur();
        }
    };

    return (
        <div className={classNames(cls.wrapper)}>
            <input
                ref={inputRef}
                onBlur={onSubmit}
                onChange={onChangeHandler}
                onKeyDown={onKeyDownHandler}
                value={value}
                placeholder={'0'}
                type={'number'}
                disabled={isDisabled}
                className={classNames(cls.DateInput, [classes])}
            />
        </div>
    );
};
